module.exports = __webpack_public_path__ + "img/orange_035.83bfecc0.png";